import { globalStyle, style, styleVariants } from '@vanilla-extract/css';
import { PlumaButton as PlumaButtonCss } from '@customerio/pluma-components/css/components';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

// Pluma's palette is the same in both schemes, so each dark-mode colour is set here.
const darkScheme = '[data-pluma-color-scheme="dark"] &';

export const mark = style({ flex: 'none' }, 'flex-mark');

// Pluma's icon sizes, so the mark lines up with the icons next to it: 16, 20 and 24px.
export const markSize = styleVariants(
  {
    sm: themeVars.space['icon-v2-sm'],
    md: themeVars.space['icon-v2-md'],
    lg: themeVars.space['icon-v2-lg'],
  },
  (size) => ({ width: size, height: size }),
  'flex-mark-size',
);

export const body = style(
  {
    fill: themeVars.palette['teal-900'],
    selectors: { [darkScheme]: { fill: themeVars.palette['verdant-50'] } },
  },
  'flex-mark-body',
);
export const accent = style({ fill: themeVars.palette['verdant-200'] }, 'flex-mark-accent');

/** In a caution banner the mark takes the banner's colours, as the Credits Lifecycle prototype does. */
export const caution = style({}, 'flex-mark-caution');
globalStyle(`.${caution} .${body}`, { fill: themeVars.color['scope-caution-subtle-mark'] });
globalStyle(`.${caution} .${accent}`, { fill: themeVars.color['scope-caution-mark'] });

/** On a solid button the body takes the button's text colour, so it reads in both schemes. */
export const solid = style({}, 'flex-mark-solid');
globalStyle(`.${solid} .${body}`, { fill: 'currentColor' });

/** In a warning or critical control the whole mark takes the text colour. */
export const mono = style({}, 'flex-mark-mono');
globalStyle(`.${mono} .${body}, .${mono} .${accent}`, { fill: 'currentColor' });

const tileBase = style(
  {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 'none',
    boxSizing: 'border-box',
    backgroundColor: themeVars.palette['teal-25'],
    border: `${themeVars.border['width-0125']} solid ${themeVars.palette['teal-100']}`,
    selectors: {
      [darkScheme]: {
        backgroundColor: themeVars.palette['teal-950'],
        borderColor: themeVars.palette['teal-800'],
      },
    },
  },
  'flex-mark-tile',
);

export const tileShape = styleVariants(
  {
    square: { borderRadius: themeVars.radius['4'] },
    circle: { borderRadius: themeVars.radius.full },
  },
  (radius) => [tileBase, radius],
  'flex-mark-tile-shape',
);

// Each tile is its mark plus an even inset: 16 in 24, 20 in 32 and 24 in 40.
export const tileSize = styleVariants(
  {
    sm: themeVars.space['300'],
    md: themeVars.space['400'],
    lg: themeVars.space['500'],
  },
  (size) => ({ width: size, height: size }),
  'flex-mark-tile-size',
);

/**
 * For a Pluma Button with the mark in `elementBefore`. Pluma gives the tighter leading padding only to
 * `iconLeading`, and the mark is not a Pluma icon, so this applies the same icon padding.
 */
export const leadingMarkButton = style(
  { vars: { [PlumaButtonCss.vars.paddingInlineStart]: PlumaButtonCss.resolvedVars.iconPadding } },
  'flex-mark-leading-button',
);
